/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { debounce } from 'lodash';

import { store } from '../store';
import { authRefreshUser } from '../store/auth/actions';

const REFRESH_BEFORE_EXPIRATION_IN_MS = 10_000;

/**
 * Will trigger a JWT refresh before it actually expires.
 */
export const debounceJwtRefresh = (expires: Date) => {
  const wait = Math.max(expires.getTime() - new Date().getTime() - REFRESH_BEFORE_EXPIRATION_IN_MS, 0);
  debounce(() => store.dispatch(authRefreshUser()), wait)();
};
